import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AttentionPopup from './AttentionPopup'
import { Button, PrimaryButton, SelectRowButton } from '../../../common/Buttons'
import { fetchActionItemsCountInfo } from '../../../redux/taskSlice'

const UserAttentionPopup = () => {
  const { showAttentionPopup } = useSelector((state) => state.auth)
  const { count_info } = useSelector((state) => state.task)
  const [show, setShow] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    let timeoutId;
    if (showAttentionPopup) {
      dispatch(fetchActionItemsCountInfo())
      const hasShown = localStorage.getItem('userAttentionPopupShown')
      if (hasShown === null) {
        timeoutId = setTimeout(() => {
          setShow(true)
          localStorage.setItem('userAttentionPopupShown', 'true')
        }, 5000)
      }
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [showAttentionPopup, dispatch])

  if (!show) return null

  const handleClose = () => {
    setShow(false)
  }

  const handleOpenActionItems = () => {
    setShow(false)
    navigate('/actionitems')
  }

  // const navigateToCheckList = (filter) => {
  //   setShow(false)
  //   navigate('/actionitems', { state: { filter: filter + "=true" } })
  // }

  // Parseint
  if(parseInt(count_info?.due_count) === 0 &&
    parseInt(count_info?.overdue_count) === 0 &&
    parseInt(count_info?.reassigned_count) === 0 &&
    parseInt(count_info?.rev_count)
  ){
    return null
  }

  return (
    <AttentionPopup closeModal={handleClose} color="black">
      <div className="attention-task-categories">
        {/* Tasks due soon */}
        <div className="attention-task-row">
          <span className="attention-count-circle attention-count-red">
            {count_info?.due_count}
          </span>
          <span className="attention-task-text">Tasks due soon</span>
          {/* <SelectRowButton onClick={() => navigateToCheckList("due")} /> */}
        </div>

        {/* Tasks are overdue */}
        <div className="attention-task-row">
          <span className="attention-count-circle attention-count-red">
            {count_info?.overdue_count}
          </span>
          <span className="attention-task-text">Tasks are overdue</span>
          {/* <SelectRowButton onClick={() => navigateToCheckList("is_overdue")} /> */}
        </div>

        {/* Tasks require Reassignment */}
        <div className="attention-task-row">
          <span className="attention-count-circle attention-count-blue">
            {count_info?.reassigned_count}
          </span>
          <span className="attention-task-text">
            Tasks require Reassignment
          </span>
          {/* <SelectRowButton onClick={() => navigateToCheckList("is_reassigned")} /> */}
        </div>

        {/* New Revisions should be created */}
        <div className="attention-task-row">
          <span className="attention-count-circle attention-count-blue">
            {count_info?.rev_count}
          </span>
          <span className="attention-task-text">
            New Revisions should be created
          </span>
          {/* <SelectRowButton onClick={() => navigateToCheckList("is_revision")} /> */}
        </div>
      </div>

      <div className="attention-popup-footer">
        <Button variant="gray" onClick={handleClose}>
          Close
        </Button>
        &nbsp;&nbsp;
        <PrimaryButton onClick={handleOpenActionItems}>Open Action Item</PrimaryButton>
      </div>
    </AttentionPopup>
  )
}

export default UserAttentionPopup